import React from 'react';
import { Link } from 'react-router-dom';

const SingleDetailRow = ({ piece, ind, page, mode, methods }) => {
  const { deletePiece, updatePiece } = methods;

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete "${piece.title}"?`)) {
      deletePiece(piece);
    }
  };

  const renderInstruments = () => {
    if (!piece.instruments?.length) return <div>No instruments</div>;

    return piece.instruments.map(data => (
      <div key={data.id} className="detail-item">
        <div><label>Name: </label>{data.title}</div>
        <div>
          <label>Audio: </label>
          {data.audio_file ? (
            <a target="_blank" rel="noopener noreferrer" href={data.audio_file}>
              {data.audio_file}
            </a>
          ) : 'N/A'}
        </div>
        <div>
          <label>Printed: </label>
          {data.printed ? (
            <a target="_blank" rel="noopener noreferrer" href={data.printed}>
              {data.printed}
            </a>
          ) : 'N/A'}
        </div>
        <div><label>Order: </label>{data.order}</div>
      </div>
    ));
  };

  const renderVideos = () => {
    if (!piece.videos?.length) return <div>No videos</div>;

    return piece.videos.map(data => (
      <div key={data.id} className="detail-item">
        <div>
          <label>Video: </label>
          {data.video_file ? (
            <a target="_blank" rel="noopener noreferrer" href={data.video_file}>
              {data.video_file}
            </a>
          ) : 'N/A'}
        </div>
        <div><label>Quality Level: </label>{data.quality_level}</div>
      </div>
    ));
  };

  const renderInterviews = () => {
    if (!piece.interviews?.length) return <div>No interviews</div>;

    return piece.interviews.map(data => (
      <div key={data.id} className="detail-item">
        <div><label>Title: </label>{data.title}</div>
        <div><label>Artist: </label>{data.artist}</div>
        <div>
          <label>Video: </label>
          {data.audio ? (
            <a target="_blank" rel="noopener noreferrer" href={data.audio}>
              {data.audio}
            </a>
          ) : 'N/A'}
        </div>
        <div><label>Order: </label>{data.order}</div>
      </div>
    ));
  };

  const renderCloseups = () => {
    if (!piece.closeups?.length) return <div>No closeups</div>;

    return piece.closeups.map(data => (
      <div key={data.id} className="detail-item">
        <div><label>Artist: </label>{data.artist}</div>
        <div><label>Instrument: </label>{data.instrument}</div>
        <div>
          <label>Video: </label>
          {data.video ? (
            <a target="_blank" rel="noopener noreferrer" href={data.video}>
              {data.video}
            </a>
          ) : 'N/A'}
        </div>
        <div><label>Order: </label>{data.order}</div>
      </div>
    ));
  };

  // If piece doesn't have required data, show empty row
  if (!piece || !piece.interviews || !piece.closeups) {
    return (
      <tr>
        <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
          Loading piece details...
        </td>
      </tr>
    );
  }

  return (
    <tr key={piece.id} className="singleDetailRow">
      <td>{(page.current - 1) * page.size + (ind + 1)}</td>
      <td>{piece.title}</td>
      <td>{renderInstruments()}</td>
      <td>{renderVideos()}</td>
      <td>{renderInterviews()}</td>
      <td>{renderCloseups()}</td>
      <td style={{ textAlign: 'center' }}>
        {mode === 'edit' ? (
          <div className="action-buttons">
            <Link
              className="cus-btn-primary"
              to={`/piece/edit/${piece.id}`}
              aria-label={`Edit ${piece.title}`}
            >
              Edit
            </Link>
            <button
              className="cus-btn-danger mr-15"
              onClick={handleDelete}
              aria-label={`Delete ${piece.title}`}
            >
              Delete
            </button>
          </div>
        ) : (
          <Link
            className="cus-btn-primary"
            to={`/piece/view/${piece.id}`}
            aria-label={`View ${piece.title}`}
          >
            View
          </Link>
        )}
      </td>
    </tr>
  );
};

export default SingleDetailRow;
